import React from 'react'
import { ModuleNames } from '../../../../constants/componentNames.constants'
import ImgUtil from '../../../../utils/img.utils'
import { isExternalURL } from '../../../../utils/link.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'
import Button from '../../button'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'
import { MinMegaMenuSection, MinNavLink, MinNavLinksWrapper, MinNavSubListItem } from '../style'

type MenuGroupProps = {
  newGroupName: string
  pages: any
  parentLink?: string
  groupStyle: string
  id: string
}

const handleAccordionOpen = (event: any) => {
  const current = event.currentTarget
  const parent = event.currentTarget.parentElement

  if (current.classList.contains('is-active')) {
    current.classList.remove('is-active')
    parent.classList.remove('MinNavLink__Active')
  } else {
    let menuItems = document.querySelectorAll('.MinNav__Dropdown_Button')

    for (let item of menuItems) {
      if (item !== event.currentTarget) {
        const itemParent = item.parentElement
        itemParent?.classList.remove('MinNavLink__Active')
        item.classList.remove('is-active')
      }
    }

    parent.classList.add('MinNavLink__Active')
    current.classList.add('is-active')
  }
}

export const MinNavLinks = ({ menuGroups, uiPathSrc }: any) => (
  <MinNavLinksWrapper>
    {menuGroups?.map((menuGroup: MenuGroupProps, i: number) => {
      const { newGroupName, pages, id } = menuGroup

      return (
        <MinNavLink key={id || i}>
          <button className="MinNav__Dropdown_Button Menu-item" onClick={handleAccordionOpen}>
            <Typography type="header6" className="MinNav__Link_Name">
              {newGroupName}
            </Typography>
          </button>

          {MinMegaNav(pages, uiPathSrc)}
        </MinNavLink>
      )
    })}
  </MinNavLinksWrapper>
)

const MinMegaNav = (megaNavDataList: any, uiPathSrc: string) => {
  return (
    <ul className="MinNav__Megamenu">
      {megaNavDataList?.map((megaNavData: any) => {
        const isMainNavBanner = megaNavData?.__typename === ModuleNames.MAIN_NAV_BANNER
        if (!megaNavData || JSON.stringify(megaNavData) === '{}' || isMainNavBanner) return null
        const hasIconLink =
          megaNavData?.pages && megaNavData?.pages[0]?.__typename === ModuleNames.TOPIC_ICON_LINK

        const displaySublistComponent = (
          subItems: any,
          newGroupName: string,
          menuGroupDescription: string
        ) => {
          const mid = Math.ceil(subItems?.length / 2) || 0
          const leftPages = subItems?.slice(0, mid) || []
          const rightPages = subItems?.slice(mid) || []

          const sectionName = (
            <Typography type="label" className="MinNav__Section_Name">
              {newGroupName}
            </Typography>
          )

          const sectionDescription = (
            <Typography type="caption" className="MinNav__Section_Description">
              {formatInlineCode(menuGroupDescription)}
            </Typography>
          )

          return (
            <>
              <div className="MinNav__Section_Content">
                {newGroupName && sectionName}
                {menuGroupDescription && sectionDescription}
              </div>

              {leftPages.length && (
                <div className="SubList__Left">{SubItemList(leftPages, uiPathSrc)}</div>
              )}

              {rightPages.length && (
                <div className="SubList__Right">{SubItemList(rightPages, uiPathSrc)}</div>
              )}
            </>
          )
        }

        megaNavData.highlightedLinks?.forEach((highlightedLink: any) => {
          highlightedLink.isHighlightedLink = true
        })

        const pagesWithHighlightedLinks = megaNavData?.pages?.concat(
          megaNavData?.highlightedLinks || []
        )

        return (
          <MinMegaMenuSection
            key={megaNavData.id}
            textColor={megaNavData.groupNameColor}
            hasIconLink={hasIconLink}>
            {displaySublistComponent(
              pagesWithHighlightedLinks,
              megaNavData?.newGroupName,
              megaNavData?.menuGroupDescription
            )}
          </MinMegaMenuSection>
        )
      })}
    </ul>
  )
}

const SubItemList = (subList: any, uiPathSrc: string) =>
  subList?.map((subItem: any) => {
    const { internalLink, icon, ctaText, description, id, __typename, isHighlightedLink, text } =
      subItem

    const internalLinkSrc = internalLink?.slug && uiPathSrc + internalLink.slug
    const subListUrl = subItem?.externalUrl || internalLinkSrc || subItem?.url || '#'
    const iconUrl = subItem?.icon?.image?.file?.url || '#'
    const target = isExternalURL(subListUrl) ? '_blank' : '_self'

    const iconImg = (
      <WrapperImage
        src={ImgUtil.getResizedImageUrl(subItem?.icon?.image?.file?.url, '')}
        width={18}
        alt={icon?.altText}
      />
    )

    const iconLabel = <Typography type="bodyXS">{ctaText}</Typography>

    const iconDescription = (
      <Typography type="caption" className="Navbar__IconLink_Caption">
        {description}
      </Typography>
    )

    return (
      <MinNavSubListItem key={id}>
        {__typename === ModuleNames.TOPIC_ICON_LINK ? (
          <a href={subListUrl} target={target} className="MinNav__SubList_IconLink">
            <div className="MinNav__IconLink_Header">
              {iconUrl && iconImg}
              {ctaText && iconLabel}
            </div>
            {description && iconDescription}
          </a>
        ) : isHighlightedLink ? (
          <Button
            className="MinNav__HighlightedLink"
            icon={true}
            type={'text-link'}
            theme={'light'}
            href={subListUrl}
            text={text}
            size="medium"
            arrowOrientation="right"
          />
        ) : (
          <a href={subListUrl} target={target} className="MinNav__SubList_Cta">
            <Typography type="bodyXS">{text}</Typography>
          </a>
        )}
      </MinNavSubListItem>
    )
  })
